import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import ErrorPage from "./pages/ErrorPage";
import Booking from "./pages/Booking";
import ContactForm from "./pages/ContactForm";
import FormSubmitted from "./pages/FormSubmitted";

const root = ReactDOM.createRoot(document.getElementById('root'));
const router = createBrowserRouter([
    {
        path: "/",
        element: <App/>,
        children: [
            {
                path: "/booking",
                element: <Booking/>,
            },
            {
                path: "/contact",
                element: <ContactForm/>,
            },
            {
                path: "/form-submitted",
                element: <FormSubmitted/>,
            },
            {
                path: "/*",
                element: <ErrorPage/>,
            },
        ],
    }
]);
root.render(
    <React.StrictMode>
        <RouterProvider router={router}/>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
